"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
let VideoContainerComponent = class VideoContainerComponent {
    constructor() {
        this.showVideo = false;
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VideoContainerComponent.prototype, "url", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VideoContainerComponent.prototype, "thumbnail", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VideoContainerComponent.prototype, "title", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VideoContainerComponent.prototype, "subtitle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], VideoContainerComponent.prototype, "width", void 0);
VideoContainerComponent = __decorate([
    (0, core_1.Component)({
        selector: 'video-container',
        templateUrl: require('./video-container.component.html'),
    })
], VideoContainerComponent);
exports.default = VideoContainerComponent;
